import { gql } from "@apollo/client";

export const feedbackMutation = gql`
  mutation feedback {
    respuestaFeedback(input: $input)
      @rest(
        type: "RespuestaFeedback"
        path: "/feedback/rate"
        method: "POST"
        endpoint: "endpointFeedback"
      ) {
      idBtn
      signature
    }
  }
`;
